import React, { useState } from "react"
import { useClickOutside } from "../../utils/hooks/useClickOutside"


export const AutoPopulateInput = ({ data, inputValue, setInputValue, icon }) => {
    const [filteredSuggestions, setFilteredSuggestions] = useState([]) //for matched suggestions
    const [showSuggestions, setShowSuggestions] = useState(false)
    const [cursor, setCursor] = useState(-1)

    const onChange = (e) => {
        const userInput = e.target.value
        const dataSource = isNaN(userInput[1]) ? data.cities : data.zipcodes

        const matchedSuggestions = dataSource.sort().filter(
            isNaN(userInput) ?
            (suggestion) => suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1 :
            (suggestion) => suggestion.toString().indexOf(userInput) > -1
        )
        setInputValue(e.target.value) //set the input field value
        setFilteredSuggestions(matchedSuggestions) //set suggestions
        setShowSuggestions(true) //show suggestions dropdown
    }

    /* create an onClick event that will be emitted when a user clicks on a suggestion.
    then use setState to update the user’s input and reset our current state. */
    const onClick = (e) => {
        setFilteredSuggestions([])
        setCursor(-1)
        setInputValue(e.target.innerText)
        setShowSuggestions(false)
    }

    /* When a user is given two or more suggestions,
    the user can use the keyDown button to select any of the autocomplete suggestions. */
    const onKeyDown = (key) => {
        // keyCode 13, enter keycode 9, tab
        if(key.keyCode === 13 || key.keyCode === 9){
            setInputValue(filteredSuggestions[cursor ? cursor : 0])
            setFilteredSuggestions([])
            setCursor(-1)
        }

        if(key.keyCode === 40){
            setCursor(cursor + 1)
        }

        if(key.keyCode === 13){
            setCursor(cursor - 1)
        }
    }

    const renderSuggestions = () => {
        if(filteredSuggestions.length && showSuggestions) {
        return (
            <ul className="suggestions" id="location-dropdown">
                {filteredSuggestions.map((suggestion, i) => {
                return (
                    <li key={`suggestion${i}`} className={cursor===i ? "active" : ""} onClick={onClick}>
                    {suggestion}
                    </li>
                )
                })}
            </ul>
        )
        }
    }

    // use the hook to handle the outside click
    const domNode = useClickOutside(() => {
        setShowSuggestions(false)
    })

    return (
        <div ref={domNode}>
            <div className="fac-searchbar-input fac-searchbar-input-location" >
                <img src={icon} alt={`${icon} icon`} className="searchbar-icon" />
                <input
                    className="fac-searchbar-input-field fac-input-location-field"
                    type="text"
                    placeholder="City or zip"
                    name='search'
                    value={inputValue}
                    onChange={onChange}
                    onClick={() => setShowSuggestions(true)}
                    onKeyDown={onKeyDown} //auto populate selection
                    autoComplete="off"
                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                />
            </div>

            { renderSuggestions() }
        </div>
    )
}